import React, { Fragment, useState, useLayoutEffect, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import "./preview-sidebar.scss";
import { Icon, Spin, Menu } from "antd";

import { IWidgetPreview } from "./constants";
import { Http } from "../../../../helpers/axois";
import { logger } from "../../../../constant/winston";

import { Review } from "./review/Review";
import { Releases } from "./releases/Releases";
// import { WidgetUsage } from "./widgetUsage/WidgetUsage";
import { WidgetPreview } from "../WidgetPreview";
import { GCPENDPOINT } from '../../../../constant/common'
import { ReactComponent as LayerLeft } from "../../../../assets/svg/layer-left.svg";
import WidgetInstall from "../WidgetInstall";
import { useToast } from "../../../../helpers/commonFunction";
import { AppState } from "../../../../stateManager/store";

export const PreviewSidebar: React.FC<IWidgetPreview | {}> = (): JSX.Element => {
  const history = useHistory();
  const params: any = useParams();
  const selectedOrgId = useSelector((state: any) => state.org.selectedOrg.id)
  const currentUser = useSelector((state: any) => state.user.data.user.id)
  const { selectedOrg } = useSelector((state: AppState) => state.org)
  const loggedInUserId = useSelector((state: any) => {
      return state.user.data.user.id
  })
  const [mode, setMode] = useState<string>("Overview")
  const [preview, setPreview] = useState<IWidgetPreview | null>(null);
  const object_url = preview === null ? "" : preview.object_url
  const [review, setReview] = useState< any >([]);
  const {ErrorToast} =useToast();
  const [readme, setReadme] = useState({
    text: "",
    available: false,
  })
  const orgPermissions: any = useSelector((state: any) => {
    return state.org.orgPermissions
  }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))

  const getProductPreview = (): void => {
    if ((!orgPermissions?.includes("marketplace.PublishWidget") || !orgPermissions.includes('org.View'))&&  loggedInUserId!=selectedOrg?.owner) {
      ErrorToast("Not Authorized: Error fetching widgets")
      return
    }  
    Http.get(
      `/orgs/${selectedOrgId}/store/products/${params.productId}`
    ).subscribe((res: any) => {
      if (res) {
        setPreview(res.product);
      } else {
        logger.error("error");
      }
    }, (err) => {
      if (err === "Forbidden") {
        ErrorToast("Not Authorized: Error fetching widgets")
    }
    });
  };

  const getProductReview = (): void => {
    if ((!orgPermissions?.includes("marketplace.PublishWidget") || !orgPermissions.includes('org.View')) &&  loggedInUserId!=selectedOrg?.owner) {
      ErrorToast("Not Authorized: Error fetching reviews")
      return
    }  
    Http.get(
      `/orgs/${selectedOrgId}/store/products/${params.productId}/review`
    ).subscribe((res: any) => {
      if (res) {
        setReview(res);
      } else {
        logger.error("error");
      }
    }, (err) => {
      if (err === "Forbidden") {
        ErrorToast("Not Authorized: Error fetching reviews")
    }
    });
  };

  useLayoutEffect(() => {
    getProductPreview()
    getProductReview()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.productId]);

  useEffect(() => {
    if (object_url) {
      const endpoint = object_url.startsWith("https://") ? object_url + "/README.md" :  GCPENDPOINT + object_url + "/README.md";
      fetch(endpoint)
        .then(res => {
          if(res.status !== 200) {
            throw new Error("README unavailable")
          }
          return res.text()
        }).then(data => setReadme({ available: true, text: data }))
        .catch((err) => logger.error(err));
    }
  }, [object_url]);

  const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
  if (!preview) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
        <Spin indicator={antIcon} />
      </div>)
  }

  const { reviews, version_tag, created_by } = preview;
  const totalRatings = reviews.reduce((acc: any, item: any) => {
    acc += item.rating ? item.rating : 0
    return acc;
  }, 0);
  const avgRating = Number(totalRatings ? (totalRatings / reviews.length) : 0).toFixed(2);
  const accessibility = currentUser === created_by.id

  return (
    <Fragment>
      {accessibility ?
        <>
          <div className="widget-header" style={{ position: "relative" }}>
            <div className="widget">
              <LayerLeft className="widget-icon" onClick={() => history.goBack()} fill={"black"} />
              <span className="widget-title"> {preview.name}</span>
              {preview.updatedVersionId !== preview.current_version_id && 
              <div style={{ position: "absolute", right: "20px" }}>
                <WidgetInstall type="update" widgetId={preview.id} orgId={selectedOrgId} is_installed={preview.is_installed} name={preview.name} />
              </div>}

            </div>
          </div>
          <div className="preview-container">
            <div className="previewlist-container">
              <Menu>
                <Menu.Item onClick={() => { setMode('Overview') }}>Overview</Menu.Item>
                {/* <Menu.Item onClick={() => { setMode('Widegt Usage') }}>Widegt Usage</Menu.Item> */}
                <Menu.Item onClick={() => { setMode('Review') }}>Review</Menu.Item>
                <Menu.Item onClick={() => { setMode('Releases') }}>Releases</Menu.Item>
              </Menu>
            </div>
            <div className="detail-view">
              {(() => {
                switch (mode) {
                  case "Overview":
                    return (
                      <WidgetPreview
                        preview={preview}
                        getProductPreview={getProductPreview}
                        getProductReview={getProductReview}
                        selectedOrg={selectedOrgId}
                        productId={params.productId}
                        currentUser={currentUser}
                        avgRating={avgRating}
                        accessibility={accessibility}
                        version_tag={version_tag}
                        review={review}
                        readme={readme}
                      />
                    )
                  // case "Widegt Usage":
                  //   return (
                  //     <WidgetUsage />
                  //   )
                  case "Review":
                    return (
                      <Review
                        avgRating={avgRating}
                        review={review}
                      />
                    )
                  case "Releases":
                    return (
                      <Releases
                        productId={params.productId}
                        preview={preview}
                      />
                    )
                }
              })()}
            </div>
          </div>
        </>
        :
        <div>
          <WidgetPreview
            preview={preview}
            getProductPreview={getProductPreview}
            getProductReview={getProductReview}
            selectedOrg={selectedOrgId}
            productId={params.productId}
            currentUser={currentUser}
            avgRating={avgRating}
            accessibility={accessibility}
            version_tag={version_tag}
            review={review}
            readme={readme}
          />
        </div>
      }
    </Fragment>
  );
};
